// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row__cbBxDYNJke{min-height:64px}`, "",{"version":3,"sources":["webpack://./src/assets/components/teamPageNew/components/teamTableLoading/teamTableLoading.module.scss"],"names":[],"mappings":"AAAA,iBACE,eAAA","sourcesContent":[".row {\n  min-height: 64px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row__cbBxDYNJke`
};
export default ___CSS_LOADER_EXPORT___;
